module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/frn_fig_003.png"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "h1",
    attrs: {
      "id": "sigil_toc_id_3"
    }
  }, [_c('span', {
    staticClass: "textStyle011"
  }, [_vm._v("Illustrations and Tables")])]), _vm._v(" "), _c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "sigil_toc_id_4"
    }
  }, [_c('span', {
    staticClass: "textStyle014"
  }, [_vm._v("Photographs")])]), _vm._v(" "), _c('table', {
    attrs: {
      "width": "99%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle9"
  }, [_vm._v("Plutarco Elías Lucero")])]), _vm._v(" "), _c('td', {
    staticClass: "right",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle9"
  }, [_vm._v("3")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle9"
  }, [_vm._v("María Jesús Campuzano Noriega")])]), _vm._v(" "), _c('td', {
    staticClass: "right",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle9"
  }, [_vm._v("4")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle9"
  }, [_vm._v("Plutarco Elías Calles in the classroom")])]), _vm._v(" "), _c('td', {
    staticClass: "right",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle9"
  }, [_vm._v("17")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle9"
  }, [_vm._v("Resting on the battlefield")])]), _vm._v(" "), _c('td', {
    staticClass: "right",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle9"
  }, [_vm._v("41")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle9"
  }, [_vm._v("A")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle4"
  }, [_vm._v("soldadera")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle9"
  }, [_vm._v("in Calles’s army")])]), _vm._v(" "), _c('td', {
    staticClass: "right",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle9"
  }, [_vm._v("57")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle9"
  }, [_vm._v("Gompers visits Obregón and Calles")])]), _vm._v(" "), _c('td', {
    staticClass: "right",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle9"
  }, [_vm._v("100")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle9"
  }, [_vm._v("The presidential inauguration")])]), _vm._v(" "), _c('td', {
    staticClass: "right",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle9"
  }, [_vm._v("114")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle9"
  }, [_vm._v("The Elías Calles-Chacón family in 1926")])]), _vm._v(" "), _c('td', {
    staticClass: "right",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle9"
  }, [_vm._v("136")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle9"
  }, [_vm._v("On the way to exile")])]), _vm._v(" "), _c('td', {
    staticClass: "right",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle9"
  }, [_vm._v("184")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle9"
  }, [_vm._v("A demonstration of national unity")])]), _vm._v(" "), _c('td', {
    staticClass: "right",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle9"
  }, [_vm._v("194")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle9"
  }, [_vm._v("Front side of “Calles” 100,000-peso bill")])]), _vm._v(" "), _c('td', {
    staticClass: "right",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle9"
  }, [_vm._v("203")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle9"
  }, [_vm._v("Reverse side of “Calles” new 100-peso bill")])]), _vm._v(" "), _c('td', {
    staticClass: "right",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle9"
  }, [_vm._v("203")])])])])]), _vm._v(" "), _c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "sigil_toc_id_5"
    }
  }, [_c('span', {
    staticClass: "textStyle014"
  }, [_vm._v("Maps")])]), _vm._v(" "), _c('table', {
    attrs: {
      "width": "99%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle9"
  }, [_vm._v("1.1.    Sonora in 1910")])]), _vm._v(" "), _c('td', {
    staticClass: "right",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle9"
  }, [_vm._v("7")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle9"
  }, [_vm._v("1.2.    Mexico in 1910")])]), _vm._v(" "), _c('td', {
    staticClass: "right",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle9"
  }, [_vm._v("13")])])])])]), _vm._v(" "), _c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "sigil_toc_id_6"
    }
  }, [_c('span', {
    staticClass: "textStyle014"
  }, [_vm._v("Tables")])]), _vm._v(" "), _c('table', {
    attrs: {
      "width": "99%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle9"
  }, [_vm._v("1.1.    The Immediate Family of Plutarco Elías Campuzano")])]), _vm._v(" "), _c('td', {
    staticClass: "right",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle9"
  }, [_vm._v("10")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle9"
  }, [_vm._v("4.1.    The Elías Calles-Chacón Clan")])]), _vm._v(" "), _c('td', {
    staticClass: "right",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle9"
  }, [_vm._v("95")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47c0be0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/IllustrationsandTables.vue
// module id = 75
// module chunks = 0